import { render, staticRenderFns } from "./BoardSettingsForm.vue?vue&type=template&id=b04d94d4&scoped=true&"
import script from "./BoardSettingsForm.vue?vue&type=script&lang=ts&"
export * from "./BoardSettingsForm.vue?vue&type=script&lang=ts&"
import style0 from "./BoardSettingsForm.vue?vue&type=style&index=0&id=b04d94d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04d94d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VColorPicker,VDivider,VForm,VMenu,VRow})
